/**
 * @flow
 * @relayHash ea9ae1423ee242a198d0adf86e987af3
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type DeliverableList_deliverables$ref = any;
type DeliverableList_stateTypes$ref = any;
export type DeliverableListPageQueryVariables = {|
  first?: ?number,
  after?: ?string,
  orderBy?: ?string,
  includeInactive?: ?boolean,
  state?: ?string,
  title?: ?string,
  releaseId?: ?string,
  productId?: ?string,
  tags?: ?string,
  dueDateFrom?: ?any,
  dueDateTo?: ?any,
  staffCoordinator?: ?string,
  assignedToStaffOrContractor?: ?string,
  includeClosed?: ?boolean,
  includeCanceled?: ?boolean,
  category?: ?string,
  categoryType?: ?string,
  onlyFollowed?: ?boolean,
|};
export type DeliverableListPageQueryResponse = {|
  +__type: ?{|
    +$fragmentRefs: DeliverableList_stateTypes$ref
  |},
  +$fragmentRefs: DeliverableList_deliverables$ref,
|};
export type DeliverableListPageQuery = {|
  variables: DeliverableListPageQueryVariables,
  response: DeliverableListPageQueryResponse,
|};
*/

/*
query DeliverableListPageQuery(
  $first: Int
  $after: String
  $orderBy: String
  $includeInactive: Boolean
  $state: String
  $title: String
  $releaseId: String
  $productId: String
  $tags: String
  $dueDateFrom: Date
  $dueDateTo: Date
  $staffCoordinator: String
  $assignedToStaffOrContractor: String
  $includeClosed: Boolean
  $includeCanceled: Boolean
  $category: ID
  $categoryType: ID
  $onlyFollowed: Boolean
) {
  ...DeliverableList_deliverables
  __type(name: "DeliverableState") {
    ...DeliverableList_stateTypes
  }
}

fragment DeliverableList_deliverables on Query {
  allDeliverables(first: $first, after: $after, orderBy: $orderBy, includeInactive: $includeInactive, state: $state, title: $title, releaseId: $releaseId, productId: $productId, tags: $tags, dueDateFrom: $dueDateFrom, dueDateTo: $dueDateTo, staffCoordinator: $staffCoordinator, assignedToStaffOrContractor: $assignedToStaffOrContractor, includeClosed: $includeClosed, includeCanceled: $includeCanceled, category: $category, categoryType: $categoryType, onlyFollowed: $onlyFollowed) {
    edges {
      cursor
      node {
        id
        deliverableId
        title
        reviewStep
        state
        dueDate
        release {
          name
          id
          product {
            id
            title
          }
        }
        category {
          id
          name
        }
        amount
        currencyCode
        amountInHomeCurrency
        isCurrentUserFollowing
        assignedContractor {
          id
          representativeImageUrl
          fullName
        }
        assignedInternally {
          id
          representativeImageUrl
          fullName
        }
        assignedStaff {
          id
          fullName
          representativeImageUrl
          user {
            id
          }
        }
        job {
          id
        }
      }
    }
    totalCount
    edgeCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}

fragment DeliverableList_stateTypes on __Type {
  enumValues {
    name
    description
  }
}
*/

const node /*: ConcreteRequest*/ = (function () {
  var v0 = [
      {
        kind: 'LocalArgument',
        name: 'first',
        type: 'Int',
        defaultValue: null
      },
      {
        kind: 'LocalArgument',
        name: 'after',
        type: 'String',
        defaultValue: null
      },
      {
        kind: 'LocalArgument',
        name: 'orderBy',
        type: 'String',
        defaultValue: null
      },
      {
        kind: 'LocalArgument',
        name: 'includeInactive',
        type: 'Boolean',
        defaultValue: null
      },
      {
        kind: 'LocalArgument',
        name: 'state',
        type: 'String',
        defaultValue: null
      },
      {
        kind: 'LocalArgument',
        name: 'title',
        type: 'String',
        defaultValue: null
      },
      {
        kind: 'LocalArgument',
        name: 'releaseId',
        type: 'String',
        defaultValue: null
      },
      {
        kind: 'LocalArgument',
        name: 'productId',
        type: 'String',
        defaultValue: null
      },
      {
        kind: 'LocalArgument',
        name: 'tags',
        type: 'String',
        defaultValue: null
      },
      {
        kind: 'LocalArgument',
        name: 'dueDateFrom',
        type: 'Date',
        defaultValue: null
      },
      {
        kind: 'LocalArgument',
        name: 'dueDateTo',
        type: 'Date',
        defaultValue: null
      },
      {
        kind: 'LocalArgument',
        name: 'staffCoordinator',
        type: 'String',
        defaultValue: null
      },
      {
        kind: 'LocalArgument',
        name: 'assignedToStaffOrContractor',
        type: 'String',
        defaultValue: null
      },
      {
        kind: 'LocalArgument',
        name: 'includeClosed',
        type: 'Boolean',
        defaultValue: null
      },
      {
        kind: 'LocalArgument',
        name: 'includeCanceled',
        type: 'Boolean',
        defaultValue: null
      },
      {
        kind: 'LocalArgument',
        name: 'category',
        type: 'ID',
        defaultValue: null
      },
      {
        kind: 'LocalArgument',
        name: 'categoryType',
        type: 'ID',
        defaultValue: null
      },
      {
        kind: 'LocalArgument',
        name: 'onlyFollowed',
        type: 'Boolean',
        defaultValue: null
      }
    ],
    v1 = [
      {
        kind: 'Literal',
        name: 'name',
        value: 'DeliverableState'
      }
    ],
    v2 = {
      kind: 'ScalarField',
      alias: null,
      name: 'id',
      args: null,
      storageKey: null
    },
    v3 = {
      kind: 'ScalarField',
      alias: null,
      name: 'title',
      args: null,
      storageKey: null
    },
    v4 = {
      kind: 'ScalarField',
      alias: null,
      name: 'name',
      args: null,
      storageKey: null
    },
    v5 = {
      kind: 'ScalarField',
      alias: null,
      name: 'representativeImageUrl',
      args: null,
      storageKey: null
    },
    v6 = {
      kind: 'ScalarField',
      alias: null,
      name: 'fullName',
      args: null,
      storageKey: null
    },
    v7 = [(v2 /*: any*/), (v5 /*: any*/), (v6 /*: any*/)],
    v8 = [(v2 /*: any*/)];
  return {
    kind: 'Request',
    fragment: {
      kind: 'Fragment',
      name: 'DeliverableListPageQuery',
      type: 'Query',
      metadata: null,
      argumentDefinitions: (v0 /*: any*/),
      selections: [
        {
          kind: 'LinkedField',
          alias: null,
          name: '__type',
          storageKey: '__type(name:"DeliverableState")',
          args: (v1 /*: any*/),
          concreteType: '__Type',
          plural: false,
          selections: [
            {
              kind: 'FragmentSpread',
              name: 'DeliverableList_stateTypes',
              args: null
            }
          ]
        },
        {
          kind: 'FragmentSpread',
          name: 'DeliverableList_deliverables',
          args: null
        }
      ]
    },
    operation: {
      kind: 'Operation',
      name: 'DeliverableListPageQuery',
      argumentDefinitions: (v0 /*: any*/),
      selections: [
        {
          kind: 'LinkedField',
          alias: null,
          name: 'allDeliverables',
          storageKey: null,
          args: [
            {
              kind: 'Variable',
              name: 'after',
              variableName: 'after'
            },
            {
              kind: 'Variable',
              name: 'assignedToStaffOrContractor',
              variableName: 'assignedToStaffOrContractor'
            },
            {
              kind: 'Variable',
              name: 'category',
              variableName: 'category'
            },
            {
              kind: 'Variable',
              name: 'categoryType',
              variableName: 'categoryType'
            },
            {
              kind: 'Variable',
              name: 'dueDateFrom',
              variableName: 'dueDateFrom'
            },
            {
              kind: 'Variable',
              name: 'dueDateTo',
              variableName: 'dueDateTo'
            },
            {
              kind: 'Variable',
              name: 'first',
              variableName: 'first'
            },
            {
              kind: 'Variable',
              name: 'includeCanceled',
              variableName: 'includeCanceled'
            },
            {
              kind: 'Variable',
              name: 'includeClosed',
              variableName: 'includeClosed'
            },
            {
              kind: 'Variable',
              name: 'includeInactive',
              variableName: 'includeInactive'
            },
            {
              kind: 'Variable',
              name: 'onlyFollowed',
              variableName: 'onlyFollowed'
            },
            {
              kind: 'Variable',
              name: 'orderBy',
              variableName: 'orderBy'
            },
            {
              kind: 'Variable',
              name: 'productId',
              variableName: 'productId'
            },
            {
              kind: 'Variable',
              name: 'releaseId',
              variableName: 'releaseId'
            },
            {
              kind: 'Variable',
              name: 'staffCoordinator',
              variableName: 'staffCoordinator'
            },
            {
              kind: 'Variable',
              name: 'state',
              variableName: 'state'
            },
            {
              kind: 'Variable',
              name: 'tags',
              variableName: 'tags'
            },
            {
              kind: 'Variable',
              name: 'title',
              variableName: 'title'
            }
          ],
          concreteType: 'DeliverableNodeConnection',
          plural: false,
          selections: [
            {
              kind: 'LinkedField',
              alias: null,
              name: 'edges',
              storageKey: null,
              args: null,
              concreteType: 'DeliverableNodeEdge',
              plural: true,
              selections: [
                {
                  kind: 'ScalarField',
                  alias: null,
                  name: 'cursor',
                  args: null,
                  storageKey: null
                },
                {
                  kind: 'LinkedField',
                  alias: null,
                  name: 'node',
                  storageKey: null,
                  args: null,
                  concreteType: 'DeliverableNode',
                  plural: false,
                  selections: [
                    (v2 /*: any*/),
                    {
                      kind: 'ScalarField',
                      alias: null,
                      name: 'deliverableId',
                      args: null,
                      storageKey: null
                    },
                    (v3 /*: any*/),
                    {
                      kind: 'ScalarField',
                      alias: null,
                      name: 'reviewStep',
                      args: null,
                      storageKey: null
                    },
                    {
                      kind: 'ScalarField',
                      alias: null,
                      name: 'state',
                      args: null,
                      storageKey: null
                    },
                    {
                      kind: 'ScalarField',
                      alias: null,
                      name: 'dueDate',
                      args: null,
                      storageKey: null
                    },
                    {
                      kind: 'LinkedField',
                      alias: null,
                      name: 'release',
                      storageKey: null,
                      args: null,
                      concreteType: 'ReleaseNode',
                      plural: false,
                      selections: [
                        (v4 /*: any*/),
                        (v2 /*: any*/),
                        {
                          kind: 'LinkedField',
                          alias: null,
                          name: 'product',
                          storageKey: null,
                          args: null,
                          concreteType: 'ProductNode',
                          plural: false,
                          selections: [(v2 /*: any*/), (v3 /*: any*/)]
                        }
                      ]
                    },
                    {
                      kind: 'LinkedField',
                      alias: null,
                      name: 'category',
                      storageKey: null,
                      args: null,
                      concreteType: 'CategoryNode',
                      plural: false,
                      selections: [(v2 /*: any*/), (v4 /*: any*/)]
                    },
                    {
                      kind: 'ScalarField',
                      alias: null,
                      name: 'amount',
                      args: null,
                      storageKey: null
                    },
                    {
                      kind: 'ScalarField',
                      alias: null,
                      name: 'currencyCode',
                      args: null,
                      storageKey: null
                    },
                    {
                      kind: 'ScalarField',
                      alias: null,
                      name: 'amountInHomeCurrency',
                      args: null,
                      storageKey: null
                    },
                    {
                      kind: 'ScalarField',
                      alias: null,
                      name: 'isCurrentUserFollowing',
                      args: null,
                      storageKey: null
                    },
                    {
                      kind: 'LinkedField',
                      alias: null,
                      name: 'assignedContractor',
                      storageKey: null,
                      args: null,
                      concreteType: 'ContractorNode',
                      plural: false,
                      selections: (v7 /*: any*/)
                    },
                    {
                      kind: 'LinkedField',
                      alias: null,
                      name: 'assignedInternally',
                      storageKey: null,
                      args: null,
                      concreteType: 'StaffNode',
                      plural: false,
                      selections: (v7 /*: any*/)
                    },
                    {
                      kind: 'LinkedField',
                      alias: null,
                      name: 'assignedStaff',
                      storageKey: null,
                      args: null,
                      concreteType: 'StaffNode',
                      plural: false,
                      selections: [
                        (v2 /*: any*/),
                        (v6 /*: any*/),
                        (v5 /*: any*/),
                        {
                          kind: 'LinkedField',
                          alias: null,
                          name: 'user',
                          storageKey: null,
                          args: null,
                          concreteType: 'UserNode',
                          plural: false,
                          selections: (v8 /*: any*/)
                        }
                      ]
                    },
                    {
                      kind: 'LinkedField',
                      alias: null,
                      name: 'job',
                      storageKey: null,
                      args: null,
                      concreteType: 'JobNode',
                      plural: false,
                      selections: (v8 /*: any*/)
                    }
                  ]
                }
              ]
            },
            {
              kind: 'ScalarField',
              alias: null,
              name: 'totalCount',
              args: null,
              storageKey: null
            },
            {
              kind: 'ScalarField',
              alias: null,
              name: 'edgeCount',
              args: null,
              storageKey: null
            },
            {
              kind: 'LinkedField',
              alias: null,
              name: 'pageInfo',
              storageKey: null,
              args: null,
              concreteType: 'PageInfo',
              plural: false,
              selections: [
                {
                  kind: 'ScalarField',
                  alias: null,
                  name: 'hasNextPage',
                  args: null,
                  storageKey: null
                },
                {
                  kind: 'ScalarField',
                  alias: null,
                  name: 'hasPreviousPage',
                  args: null,
                  storageKey: null
                },
                {
                  kind: 'ScalarField',
                  alias: null,
                  name: 'startCursor',
                  args: null,
                  storageKey: null
                },
                {
                  kind: 'ScalarField',
                  alias: null,
                  name: 'endCursor',
                  args: null,
                  storageKey: null
                }
              ]
            }
          ]
        },
        {
          kind: 'LinkedField',
          alias: null,
          name: '__type',
          storageKey: '__type(name:"DeliverableState")',
          args: (v1 /*: any*/),
          concreteType: '__Type',
          plural: false,
          selections: [
            {
              kind: 'LinkedField',
              alias: null,
              name: 'enumValues',
              storageKey: null,
              args: null,
              concreteType: '__EnumValue',
              plural: true,
              selections: [
                (v4 /*: any*/),
                {
                  kind: 'ScalarField',
                  alias: null,
                  name: 'description',
                  args: null,
                  storageKey: null
                }
              ]
            }
          ]
        }
      ]
    },
    params: {
      operationKind: 'query',
      name: 'DeliverableListPageQuery',
      id: null,
      text:
        'query DeliverableListPageQuery(\n  $first: Int\n  $after: String\n  $orderBy: String\n  $includeInactive: Boolean\n  $state: String\n  $title: String\n  $releaseId: String\n  $productId: String\n  $tags: String\n  $dueDateFrom: Date\n  $dueDateTo: Date\n  $staffCoordinator: String\n  $assignedToStaffOrContractor: String\n  $includeClosed: Boolean\n  $includeCanceled: Boolean\n  $category: ID\n  $categoryType: ID\n  $onlyFollowed: Boolean\n) {\n  ...DeliverableList_deliverables\n  __type(name: "DeliverableState") {\n    ...DeliverableList_stateTypes\n  }\n}\n\nfragment DeliverableList_deliverables on Query {\n  allDeliverables(first: $first, after: $after, orderBy: $orderBy, includeInactive: $includeInactive, state: $state, title: $title, releaseId: $releaseId, productId: $productId, tags: $tags, dueDateFrom: $dueDateFrom, dueDateTo: $dueDateTo, staffCoordinator: $staffCoordinator, assignedToStaffOrContractor: $assignedToStaffOrContractor, includeClosed: $includeClosed, includeCanceled: $includeCanceled, category: $category, categoryType: $categoryType, onlyFollowed: $onlyFollowed) {\n    edges {\n      cursor\n      node {\n        id\n        deliverableId\n        title\n        reviewStep\n        state\n        dueDate\n        release {\n          name\n          id\n          product {\n            id\n            title\n          }\n        }\n        category {\n          id\n          name\n        }\n        amount\n        currencyCode\n        amountInHomeCurrency\n        isCurrentUserFollowing\n        assignedContractor {\n          id\n          representativeImageUrl\n          fullName\n        }\n        assignedInternally {\n          id\n          representativeImageUrl\n          fullName\n        }\n        assignedStaff {\n          id\n          fullName\n          representativeImageUrl\n          user {\n            id\n          }\n        }\n        job {\n          id\n        }\n      }\n    }\n    totalCount\n    edgeCount\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n  }\n}\n\nfragment DeliverableList_stateTypes on __Type {\n  enumValues {\n    name\n    description\n  }\n}\n',
      metadata: {}
    }
  };
})();
// prettier-ignore
(node/*: any*/).hash = 'aa328b56187d23cbbb28a991061f8933';
module.exports = node;
